import { Store } from './styles'

export function EmployeeInformationSubTitle({ children }) {
  return <Store>{children}</Store>
}
